const isElementExist = (selector) => {
  return document.body.contains(document.querySelector(selector));
};

/**
 *
 * @param {string} selector  The selector for the element to observe
 * @param {boolean} trackOnce Observe the Element only once, or fire callback every time element enters the DOM
 * @param callback - The function to execute once the element is found.
 */
const isInDom = (selector, trackOnce, callback) => {
  let element = document.querySelector(selector);
  let inDom = document.body.contains(element);
  const observer = new MutationObserver(mutations => {
    element = document.querySelector(selector);
    if (document.body.contains(element)) {
      if (!inDom) {
        if (trackOnce) {
          observer.disconnect();
        }
        callback(element);
      }
      inDom = true;
    } else if (inDom) {
      inDom = false;
    }
  });
  observer.observe(document.body, {
    childList: true, // Have elements been added/removed directly in this element?
    subtree: true, // Have elements more than one level deep changed?
  });
};

/**
 *
 * @param {string} selector  The selector for the element to observe
 * @param {boolean} trackOnce Observe the Element only once, or fire callback every time element enters the DOM
 * @param callback - The function to execute once the element is found.
 * @constructor
 */
export const IsElementReady = (selector, trackOnce, callback) => {
  if (isElementExist(selector)) {
    callback(document.querySelector(selector));
    return;
  }
  isInDom(selector, trackOnce, callback);
};

/**
 *
 * @param {string} selector  The selector for the element to observe
 * @param {boolean} trackOnce Observe the Element only once, or fire callback every time element enters the DOM
 * @param callback - The Promise to resolve once element is found
 * @constructor
 */
export const IsElementPromiseReady = (selector, trackOnce)=> {
  return new Promise(resolve => {
    IsElementReady(selector, trackOnce, (elem) => {
      resolve(elem);
    });
  });
};


/**
 *
 * @param watchElement The Element To Observer
 * @param observeOnce To only observe the element once, or to continue applying the observable.
 * @param callback - The callback function to execute Once the Element has Changed.
 */
export const ObserveElement = (watchElement, observeOnce,  callback) => {
  let observer;
  observer = new MutationObserver(observed);

  observer.observe(watchElement.parentNode, {
    childList: true, // Have elements been added/removed directly in this element?
    attributes: true, // Has the element had any changes to attributes?
    characterData: true, // Has any text inside of the element changed?
    subtree: true, // Have elements more than one level deep changed?
  });

  function observed(e) {
    if (e[0].removedNodes) {
      observeOnce && observer.disconnect(); // Disconnect old observer, so the obs don't stack.
      callback();
    }
  }
};



/**
 * @param {string} type
 * @param {json} properties
 * @param {string} text
 * @returns {HTMLElement}
 */
export const createElement = (type, properties, text) => {
  var element = document.createElement(type);
  var value = "";
  if (properties) {
    for (var key in properties) {
      value = properties[key];
      // If is an array, join the items with space
      element.setAttribute(key, Array.isArray(value) ? value.join(" ") : value);
    }
  }
  if (text) {
    element.innerHTML = text;
  }
  return element;
}



/**
 *
 * @param cents The Cent price Amount to be formated.
 * @param format - The Format to output, Default: ${{amount}}
 * @return {The String formated representation of the cents converted to money format.}
 */
export const formatMoney =(cents, format = '${{amount}}') => {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}


/**
 *
 * @param {HTMLElement} node  The HTML Elem to observe
 * @param {boolean} trackOnce Observe the Element only once, or fire callback every time element enters the DOM
 * @param callback - The function to execute once the element is found.
 */
export const observeNodeUpdateInDom = (node, trackOnce, callback) => {
  const observer = new MutationObserver(mutations => {
    if (trackOnce) {
      observer.disconnect();
    }
    const updatedMutations = mutations.filter((mutation) => {
      return mutation.addedNodes.length > 0;
    })
    callback(updatedMutations);
  });
  observer.observe(node.parentNode, {
    attributes: true,
    childList: true,
    characterData: true
  });
};

